import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from "react-router-dom";
import {
  Box,
  Chip,
  Divider,
  Stack,
  Tab,
  Tabs,
  Typography,

} from "@mui/material";
import {
  LinkRounded,
  TaskAltRounded,
  NoteAltRounded,
  ListAltRounded,
} from "@mui/icons-material";

import {
  getProject,
  addProjectLink,
  editProjectLink,
  deleteProjectLink,
  addProjectTask,
  editProjectTask,
  deleteProjectTask,
  clearProjectDoneTasks,
  addProjectList,
  renameProjectList,
  deleteProjectList,
  addProjectListItem,
  toggleProjectListItem,
  deleteProjectListItem,
  saveProjectNote

} from "../../actions/projectsActions"
import Loader from "../theme/Loader"
import LinksPanel from "./LinksPanel";
import TasksPanel from "./TasksPanel";
import ListsPanel from "./ListsPanel";
import NotesPanel from "./NotesPanel";



// ---------------------------------------------------------------------------
// Main Project Page with Tabs
// ---------------------------------------------------------------------------
export default function ProjectPageCRUD() {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const currentProject = useSelector((state) => state.currentProject);
  const currProjectId = useSelector((state) => state.param.value.currProjectId);
  const [data, setData] = useState(currentProject.data);
  const [tab, setTab] = useState(0);

  const DEFAULT_PROJECT = "project:default:id";
  useEffect(() => {
    setData(currentProject.data)


  }, [currentProject.data]);

  useEffect(() => {
    console.log(currProjectId, )
   

    if (currProjectId && currProjectId > 0) { 
      console.log("getting proj")

      dispatch(getProject(currProjectId)) 
    }
    else {
     
      navigate("/projects")
    }


  }, [currProjectId]);

  return (
    (Object.keys(data).length > 0 ?
      <Box sx={{ maxWidth: 1200, mx: "auto", px: 2, py: 4 }}>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ xs: "stretch", sm: "center" }} justifyContent="space-between" sx={{ mb: 3 }}>
          <Box>
            <Typography variant="h4" fontWeight={700}>{data.title}</Typography>
            <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
              {data.tags.map((t) => (<Chip key={t} label={t} size="small" />))}
            </Stack>
          </Box>
        </Stack>

        <Tabs value={tab} onChange={(_, v) => setTab(v)} variant="scrollable" allowScrollButtonsMobile sx={{ mb: 2 }}>
          <Tab icon={<LinkRounded />} iconPosition="start" label="Links" />
          <Tab icon={<TaskAltRounded />} iconPosition="start" label="Tasks" />
          <Tab icon={<ListAltRounded />} iconPosition="start" label="Lists" />
          <Tab icon={<NoteAltRounded />} iconPosition="start" label="Notes" />
        </Tabs>
        <Divider sx={{ mb: 3 }} />

        {tab === 0 && (
          <LinksPanel
            projectId={data.id}
            links={data.links}
            onAdd={(p) => {
              // addLink(p);
              dispatch(addProjectLink(p))
            }}
            onUpdate={(l) => {
              // updateLink(l);
              dispatch(editProjectLink(l))
            }
            }
            onDelete={(l) => {
              // deleteLink(l);
              dispatch(deleteProjectLink(l))
            }
            }
          />
        )}

        {tab === 1 && (
          <TasksPanel
            projectId={data.id}
            tasks={data.tasks}
            onAdd={
              // addTask
              (d) => dispatch(addProjectTask(data.id, d))
            }
            onToggle={
              // toggleTask
              (d) => dispatch(editProjectTask(data.id, d))
            }
            onRename={
              // renameTask
              (d) => dispatch(editProjectTask(data.id, d))
            }
            onDelete={
              // deleteTask
              (d) => dispatch(deleteProjectTask(data.id, d))
            }
            onClearDone={
              // clearDone
              () => dispatch(clearProjectDoneTasks(data.id))
            }
          />
        )}

        {tab === 2 && (
          <ListsPanel
            lists={data.lists}
            onAddList={
              (d) => dispatch(addProjectList(data.id, d))
            }
            onRenameList={
              (d) => dispatch(renameProjectList(data.id, d))
            }
            onDeleteList={
              (d) => dispatch(deleteProjectList(data.id, d))
            }
            onAddItem={
              (d) => dispatch(addProjectListItem(data.id, d))
            }
            onToggleItem={
              (d) => dispatch(toggleProjectListItem(data.id, d))
            }
            onDeleteItem={
              (d) => dispatch(deleteProjectListItem(data.id, d))
            }
          />
        )}

        {tab === 3 && (
          <NotesPanel note={data.note} onSave={
            (d) => dispatch(saveProjectNote(data.id, d))
          } />
        )}
      </Box>
      : <Loader />)
  )
    ;
}
